import React from "react";
import "./Card.css"; // Import the CSS file
import HeaderTitle from "../HederTitle/HeaderTitle";
import aboutGif from "../Assets/about-fabric.gif"
import { Link } from "react-router-dom";

const Card = () => {
  return (
    <div className="card-container">
      {/* Left Section */}
      <div className="card-left">
        <div className="steps">
          <p className="step-text">We will <span className="highlight">Develop Design</span></p>
          <div className="step">
            <img crossOrigin="anonymous"  src={aboutGif} alt="Final Fabric" className="step-image" />
          </div>
          <p className="step-text">We will <span className="highlight">print</span> on fabric of your choice</p>
        </div>
      </div>

      {/* Right Section */}
      <div className="card-right">
        {/* <div className="relative font-bold text-5xl mt-4 text-center my-3" style={{ fontFamily: "'Dancing Script', cursive" }} >About Our Fabric</div> */}
        {/* <div className="relative font-bold text-5xl mt-4 text-center my-3" >About Our Fabric</div> */}
        <p
          className="relative font-medium text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center my-6"
             style={{ fontFamily: "'Times New Roman', Serif" }}
        >
          About Our Fabric
        </p>
        <p className="description text-justify">
          Struggling to find unique fabric designs? We’ve got you covered! Whether you’re a fabric shop owner or a designer, we can help bring your ideas to life. Simply share your designs, select from our premium fabrics, and we’ll print them — with a minimum order of just 1 meter.
          We use high-quality, eco-friendly printing methods to deliver vibrant and long-lasting results while ensuring your designs remain confidential. A dedicated expert will guide you through every step, from design to delivery, making the process smooth and hassle-free. Enjoy fast delivery and top-quality fabrics tailored to your needs!</p>

        <div className="flex justify-center">
          <Link to="/explore-our-ideas">
            <button className="btn">Explore Our Ideas</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Card;
